import { Button, Tooltip, TrevorIcon } from '@trevor/ui-components';
import { toggleSharePublishEmbedSidebar } from '@/features/dashboard/dashboardSlice';
import React from 'react';
import { useDashboardId, useDatasourceId, useTimeoutToggle } from '@/hooks';
import { usePermission } from '@/hooks/usePermission';
import { useAppDispatch } from '@/store/hooks';
import { useDashboard } from '@/hooks/useDashboard';

const toggleCopyDashboardId = `toggleDashboardId`;

export const ShareDashboardButton = () => {
  const [copied, toggleCopied] = useTimeoutToggle(2000);
  const dispatch = useAppDispatch();
  const datasourceId = useDatasourceId();
  const dashboardId = useDashboardId();
  const hasPermissionToWrite = usePermission(
    `${datasourceId}.dashboards.${dashboardId}.write`,
  );

  const { shareDashboardPrivateUrl, shareDashboardPublicUrl } = useDashboard();

  const handleShareDashboard = () => {
    if (hasPermissionToWrite) {
      dispatch(toggleSharePublishEmbedSidebar());
    } else {
      window.navigator.clipboard
        .writeText(shareDashboardPublicUrl ?? shareDashboardPrivateUrl)
        .then(() => {
          toggleCopied();
        })
        .catch(() => window.alert('Oops, unable to copy'));
    }
  };

  return (
    <>
      <Button
        data-tooltip-id={toggleCopyDashboardId}
        icon={<TrevorIcon name="link" />}
        variant="secondary"
        size="small"
        onClick={handleShareDashboard}
      >
        Share
      </Button>
      {!hasPermissionToWrite && (
        <Tooltip
          id={toggleCopyDashboardId}
          variant="success"
          place="left"
          isOpen={copied}
        >
          Copied!
        </Tooltip>
      )}
    </>
  );
};
